import { ToasterService } from './../../shared/services/toaster.service';
import { Component, OnInit } from '@angular/core';
import { ApiHandlerService } from 'src/app/shared/services/api-handler.service';
import { API } from 'src/app/shared/services/endpoints';

@Component({
  selector: 'app-blog',
  templateUrl: './blog.component.html',
  styleUrls: ['./blog.component.scss']
})
export class BlogComponent implements OnInit {

  constructor(
    public _service: ApiHandlerService,
    public toaster: ToasterService
  ) { }

  ngOnInit(): void {
    let footer = document.getElementsByTagName('footer');
    footer[0].classList.add('without-cars');
    if (footer[1]) {
      footer[1].classList.add('without-cars');
    }
    this.getAllBlogs()
  }

  blogList: Array<any> = []

  ngOnDestroy() {
    let footer = document.getElementsByTagName('footer')[0];
    footer.classList.remove('without-cars');
  }

  isLoadingApiData = false;
  getAllBlogs() {
    this.isLoadingApiData = true;
    this._service.apiGet(API.CMS_ENDPOINTS.GET_ALL_BLOG).subscribe({
      next: (result: any) => {
        this.blogList = result.data.data;
      }, error: err => {
        this.toaster.Error(err.error ? err.error.message : err.message);
        this.isLoadingApiData = false;
      }, complete: () => {
        this.isLoadingApiData = false;
      }
    });

  }

}
